module.exports = __webpack_public_path__ + "static/img/kuaikeli.b1b9315.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/kuaikeli.jpg
// module id = MjaA
// module chunks = 0